import { Link } from "react-router-dom";

export default function Species(props) {
  const { type, index = 0 } = props;

  // Light species fills (yellow / orange / pink / teal) carry a dark text
  // override in the config; everything else reads white.
  const isLight = Boolean(type.colorText);
  const textColor = type.colorText || "text-white";
  const badgeClasses = isLight
    ? "bg-black/10 text-stone-800"
    : "bg-white/20 text-white";

  return (
    <Link to={type.url} className="block animate-fade-up" style={{ animationDelay: `${index * 60}ms` }}>
      <button
        className={`group relative flex flex-col items-start gap-2 overflow-hidden rounded-2xl ${type.color} ${textColor} px-5 py-4 text-left shadow-soft ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lift focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-paper`}
      >
        {/* soft sheen that sweeps on hover */}
        <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/25 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
        <span className="relative font-display text-lg italic leading-tight">
          {type.text}
        </span>
        <span
          className={`relative self-center rounded-full px-2.5 py-0.5 text-[0.7rem] font-semibold tracking-[0.12em] ${badgeClasses}`}
        >
          {type.platform}
        </span>
      </button>
    </Link>
  );
}
